import { render, staticRenderFns } from "./IconOrganizations.vue?vue&type=template&id=496b1e67"
import script from "./IconOrganizations.vue?vue&type=script&lang=js"
export * from "./IconOrganizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports